"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhoTheseServicesAreFor() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const whiskeys = [{
    region: "ELECTRICAL INFRASTRUCTURE",
    name: "Arc Flash Safety",
    age: "Compliance Standard",
    notes: ["DURABLE", "HIGH-VIS", "OSHA"],
    price: "REQUEST",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_arc_flash.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_arc_flash.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_arc_flash.png-wvc-sizes"
  }, {
    region: "INDUSTRIAL MARKING",
    name: "Phenolic Tags",
    age: "Heavy Duty",
    notes: ["CHEMICAL", "HEAT", "WEATHER"],
    price: "REQUEST",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_phenolic.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_phenolic.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_phenolic.png-wvc-sizes"
  }, {
    region: "PRECISION METAL",
    name: "Stainless Steel",
    age: "Corrosion Resistant",
    notes: ["MARINE", "FOOD", "EXTREME"],
    price: "REQUEST",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_stainless.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_stainless.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_stainless.png-wvc-sizes"
  }, {
    region: "AEROSPACE GRADE",
    name: "Anodized Aluminum",
    age: "Lightweight",
    notes: ["AIRCRAFT", "PRECISION", "LASER"],
    price: "REQUEST",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_aluminum.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_aluminum.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_aluminum.png-wvc-sizes"
  }, {
    region: "OEM SOLUTIONS",
    name: "Direct Part Marking",
    age: "Permanent ID",
    notes: ["TRACEABILITY", "SERIAL", "DPM"],
    price: "REQUEST",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_dpm.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_dpm.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_dpm.png-wvc-sizes"
  }, {
    region: "CUSTOM FABRICATION",
    name: "Engraved Brass",
    age: "Architectural",
    notes: ["PREMIUM", "VALVE", "LEGACY"],
    price: "REQUEST",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_brass.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_brass.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_brass.png-wvc-sizes"
  }, {
    region: "CONTROL PANELS",
    name: "UL 508A Labels",
    age: "Certified",
    notes: ["UL", "COMPLIANT", "SAFETY"],
    price: "REQUEST",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_ul.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_ul.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_ul.png-wvc-sizes"
  }, {
    region: "UTILITY POWER",
    name: "Substation Tags",
    age: "High Voltage",
    notes: ["WEATHER", "UV", "STABLE"],
    price: "REQUEST",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_substation.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_substation.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_substation.png-wvc-sizes"
  }, {
    region: "WATER SYSTEMS",
    name: "Flow Control Tags",
    age: "Industrial",
    notes: ["WATER", "WASTE", "FLOW"],
    price: "REQUEST",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_water.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_water.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/label_water.png-wvc-sizes"
  }];
  return <section data-section-id="2747" id="who-these-services-are-for" className="bg-background text-foreground py-24 md:py-32 lg:py-40 px-6 md:px-10 lg:px-16 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`text-center transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-mono text-xs tracking-[0.3em] mb-8" style={{
          color: "var(--chart-1)"
        }}>
            INDUSTRIES / OUR CAPABILITIES
          </p>
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-light leading-[1.1] max-w-3xl mx-auto" style={{
          color: "var(--foreground)"
        }}>
            Engineered identification solutions for every industrial sector.
          </h2>
        </div>

        <div ref={gridRef} className={`mt-20 md:mt-24 lg:mt-28 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10 transition-all duration-1000 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {whiskeys.map((whiskey, i) => <Card key={i} data-index={i} className="group bg-card rounded-lg p-10 gap-0 transition-all duration-500 ease-out hover:-translate-y-2 hover:shadow-lg border border-border" style={{
          boxShadow: "var(--shadow-lg)"
        }}>
              <div className="relative overflow-hidden rounded-lg mb-8" style={{
            aspectRatio: "4 / 5",
            background: "radial-gradient(circle at center, hsl(216 40% 20% / 0.45) 0%, hsl(0 0% 0%) 70%)"
          }}>
                <div className="absolute inset-0 opacity-60" style={{
              background: "radial-gradient(circle at 50% 60%, hsl(45 68% 47% / 0.35) 0%, transparent 60%)"
            }} />
                <img src={whiskey.image} data-wvc-srcset={whiskey.srcset} data-wvc-sizes={whiskey.sizes} alt={whiskey.name} loading="lazy" decoding="async" className="relative w-full h-full object-contain transition-transform duration-700 ease-out group-hover:scale-[1.04]" />
              </div>

              <CardContent className="px-0">
                <p className="font-mono text-[10px] tracking-[0.25em] mb-4" style={{
              color: "var(--chart-1)"
            }}>
                  {whiskey.region}
                </p>
                <h3 className="font-default text-2xl md:text-[1.75rem] font-normal leading-tight mb-2" style={{
              color: "var(--foreground)"
            }}>
                  {whiskey.name}
                </h3>
                <p className="font-default italic text-base mb-6" style={{
              color: "var(--muted-foreground)"
            }}>
                  {whiskey.age}
                </p>

                <div className="h-px w-full mb-6" style={{
              background: "linear-gradient(to right, hsl(45 68% 47% / 0.6), transparent)"
            }} />

                <div className="flex flex-wrap gap-2 mb-8">
                  {whiskey.notes.map((note, j) => <span key={j} data-index={j} className="inline-flex items-center px-3 py-1.5 rounded-md border text-[10px] font-mono tracking-[0.2em]" style={{
                borderColor: "hsl(45 68% 47% / 0.35)",
                color: "var(--muted-foreground)"
              }}>
                      {note}
                    </span>)}
                </div>

                <div className="flex items-center justify-end">
                  
                </div>
              </CardContent>
            </Card>)}
        </div>

        
      </div>
    </section>;
}